import "../styles.css";
import Nav from "./Nav";
import OrderForm from "./OrderForm";
import Footer from "./Footer";

export default function Main() {
  return (
    <div>
      <Nav />
      <OrderForm />
      <Footer />
    </div>
  );
}
